// extracted by mini-css-extract-plugin
export default {"profileContainer":"StudentProfile_profileContainer__ltheE","infoContainer":"StudentProfile_infoContainer__GcT1i"};